import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import DairyQuery from '~/QueryHooks/DairyQuery'
import Layout from '~/components/Layout'
import TypeCard from '~/components/TypeCard'

const Certifications: React.FC = () => {
  const { t } = useTranslation()

  const {
    isLoading: isBusyData,
    data: certifications,
    refetch: fetchData
  } = DairyQuery.getCertificationsList()

  useEffect(() => {
    fetchData()
  }, [t])

  const { rows } = certifications ? certifications : { rows: [] }

  return <Layout
    title={t('Certifications')}
    isBusy={isBusyData}
    childContainerSize={'auto'}
    fontSizeHeader={'18px'}
    useSpinner
  >
    <TypeCard rows={rows} />
  </Layout>
}
export default Certifications